import { NormalizedProduct } from '@ravago/shared/page-data/models/contentful-mapped';
import { ProductColor, PackagingGroup, ProductDetail } from '@ravago/shared/page-data/models/elements';

export abstract class ProductUtils {
  static async getProductByEntryId(locale: string, entryId?: string): Promise<NormalizedProduct | null> {
    const response = await fetch(`/api/products/productByEntryId?locale=${locale}&entryId=${entryId}`);

    if (!response.ok) return null;

    return response.json();
  }

  static async getProductDetails(productId: string): Promise<ProductDetail | null> {
    const response = await fetch(`/api/products/${productId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    });

    if (!response.ok) return null;

    return response.json();
  }

  static async getCustomerProductColors(productId: string): Promise<ProductColor[] | undefined> {
    const url = `/api/customer/products/${productId}/colors`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    });
    if (!response.ok) return undefined;
    return response.json();
  }

  static async getCustomerProductPackagingGroups(productId: string): Promise<PackagingGroup[] | undefined> {
    const url = `/api/customer/products/${productId}/packaging-groups`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    });
    if (!response.ok) return undefined;
    return response.json();
  }
}
